import { GetEstablishmentResponseDto } from '@EHSNavigator/backend';
import { useApiClients } from '../../client/api/useApiClient';
import OshaReporting from '../../views/OshaReporting';
import { useQuery } from '@tanstack/react-query';
import Loader from '../../components/Loader';

export default function OshaReportingPage() {
  const { EstablishmentApi } = useApiClients();

  const { data, isLoading, isRefetching } = useQuery<
    GetEstablishmentResponseDto['establishment'],
    Error,
    any
  >({
    queryKey: ['get-establishment'],
    queryFn: async () => {
      const response =
        await EstablishmentApi.establishmentControllerGetEstablishment();
      return response?.data?.establishment;
    },
  });

  if (isLoading || isRefetching) {
    return <Loader />;
  }
  return (
    <div className="relative flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <OshaReporting data={data} />
    </div>
  );
}
